<template>
  <div class="alumni-card-box">
    <div class="card-top">
      <div class="alumni-img-box" @click="goDetail">
        <img
          :src="info.aUrl"
          v-if="info.aUrl != '' && info.aUrl != null"
          alt="item.aName"
        />
        <img v-else :src="defaultAvatar" alt="" />
        <img class="sex" v-if="info.asex == 1" :src="btnNan" />
        <img class="sex" v-else :src="btnNv" />
      </div>
      <div class="alumni-info">
        <div class="alumni-name">
          <div>{{ info.aName }}</div>
          <img
            v-if="info.aRealNameAuthentication == 1"
            class="alumni-name-img"
            :src="btnRenzheng"
          />
          <div
            v-if="info.aRealNameAuthentication == 1"
            class="alumni-name-div-o"
          >
            已认证
          </div>
          <div class="alumni-name-div-t">{{ info.aCity }}</div>
        </div>
        <div class="alumni-otherInfo">
          {{ info.aDanWei }}<span v-if="info.aZhiwu"> / {{ info.aZhiwu }}</span>
        </div>
      </div>
      <div class="open" @click.stop="openCard">
        <van-icon
          :name="isOpen ? 'arrow-up' : 'arrow-down'"
          size="20px"
          color="#747474"
        />
      </div>
    </div>
    <div v-if="isOpen" class="card-bottom">
      <div class="info-detail">
        <img :src="btnXuexiao" />
        <span
          >{{ info.aCollege }} / {{ info.amajor }} {{ info.aXuejie }}级</span
        >
      </div>
      <div class="info-detail">
        <img :src="btnDianhua" />
        <span>{{
          info.isExchange ? info.aphone : phone_hide(info.aphone)
        }}</span>
      </div>
      <div class="go-detail" @click="goDetail">查看详情</div>
    </div>
  </div>
</template>

<script>
import defaultAvatar from "@/assets/image/defaultAvatar.png";
import btnXuexiao from "@/assets/image/btn_xuexiao_nor.png";
import btnDianhua from "@/assets/image/btn_dianhua_nor.png";
import btnRenzheng from "@/assets/image/btn_renzheng_nor.png";
import btnNv from "@/assets/image/btn_nv_nor.png";
import btnNan from "@/assets/image/btn_nan_nor.png";

export default {
  name: "AlumniInfoCard",
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      isOpen: false,
      defaultAvatar,
      btnXuexiao,
      btnDianhua,
      btnRenzheng,
      btnNv,
      btnNan,
    };
  },
  mounted() {},
  created() {},
  methods: {
    phone_hide(phone) {
      if (phone && phone.length === 11) {
        phone = phone.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
      }
      return phone;
    },
    openCard() {
      this.isOpen = !this.isOpen;
    },
    goDetail() {
      console.log("校友资源", this.info.aUserId);
      this.$emit("go", this.info.aUserId);
    },
  },
};
</script>

<style lang="less" scoped>
.alumni-card-box {
  padding: 0 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  border: 1px solid #f3f3f3;
  background-color: #ffffff;
  .card-top {
    position: relative;
    padding: 15px 0;
    display: flex;
    align-items: center;
    .open {
      position: absolute;
      bottom: 15px;
      right: 0;
      width: 20px;
      height: 20px;
    }
    .alumni-img-box {
      width: 60px;
      height: 60px;
      img {
        width: 60px;
        height: 60px;
        border-radius: 50%;
        // object-fit: cover;
        background-size: 100% 100%;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
      }
      .sex {
        width: 15px;
        height: 15px;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        position: absolute;
        margin-top: -3px;
        margin-left: -15px;
      }
    }
    .alumni-info {
      margin-left: 15px;
      .alumni-name {
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: 1rem;
        // border: 1px solid #888;
        color: #333333;
        font-weight: bold;
      }
      .alumni-name-img {
        position: relative;
        // width: 13px;
        // height: 16px;
        padding-top: 0px;
        image-rendering: -moz-crisp-edges;
        image-rendering: -o-crisp-edges;
        image-rendering: -webkit-optimize-contrast;
        image-rendering: crisp-edges;
        -ms-interpolation-mode: nearest-neighbor;
        margin-left: 20px;
      }
      .alumni-name-div-o {
        font-weight: 500;
        font-size: 0.8rem;
        margin-left: 5px;
      }
      .alumni-name-div-t {
        color: #248381;
        font-weight: 500;
        font-size: 0.8rem;
        margin-left: 5px;
        position: absolute;
        right: 5px;
      }
      .alumni-otherInfo {
        overflow: hidden;
        min-height: 17px;
        color: #757575;
        margin-top: 5px;
        font-size: 0.9rem;
      }
    }
  }
  .card-bottom {
    padding: 15px 0;
    border-top: 1px solid #f3f3f3;
    color: #333333;
    .info-detail {
      margin-bottom: 10px;
    }
    span {
      margin-left: 5px;
      color: #333333;
      font-size: 0.9rem;
    }
    .go-detail {
      text-align: center;
      font-weight: bold;
      color: #666666;
      font-size: 0.95rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniResources/components/AlumniInfoCard/index.vue